"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lotteryAssistant = require("@/api/lotteryAssistant");
var _permission = require("@/utils/permission");
var _enums = require("../activity/enums");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 奖品状态选项
var winStatusOptions = [{
  value: 0,
  label: '待开奖'
}, {
  value: 1,
  label: '未中奖'
}, {
  value: 2,
  label: '已中奖'
}, {
  value: 3,
  label: '已领取'
}, {
  value: 4,
  label: '已过期'
}];

// 用户类型选项
var userTypeOptions = [{
  value: 1,
  label: '真人'
}, {
  value: 2,
  label: '机器人'
}];
var _default = exports.default = {
  name: 'JoinRecord',
  directives: {
    hasPermi: {
      inserted: function inserted(el, binding) {
        var value = binding.value;
        var hasPermission = (0, _permission.checkPermi)(value);
        if (!hasPermission) {
          el.parentNode && el.parentNode.removeChild(el);
        }
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      total: 0,
      recordList: [],
      dateRange: [],
      winStatusOptions: winStatusOptions,
      userTypeOptions: userTypeOptions,
      queryParams: {
        page: 1,
        limit: 20,
        activityId: '',
        phoneNumber: '',
        redeemCode: '',
        userId: '',
        winStatus: '',
        userType: '',
        startTime: '',
        endTime: '',
        temp: new Date().getTime()
      }
    };
  },
  created: function created() {
    if ((0, _permission.checkPermi)(['platform:draw:JoinRecord:list'])) {
      this.getList();
    } else {
      this.$message.error('对不起，您没有访问权限');
    }
  },
  methods: {
    checkPermi: _permission.checkPermi,
    getList: function getList() {
      var _this = this;
      if (!(0, _permission.checkPermi)(['platform:draw:JoinRecord:list'])) {
        this.$message.error('对不起，您没有访问权限');
        return;
      }

      // 确保userId是数字类型
      if (this.queryParams.userId !== '') {
        this.queryParams.userId = parseInt(this.queryParams.userId) || '';
      }
      this.loading = true;
      this.queryParams.temp = new Date().getTime(); // 更新时间戳
      (0, _lotteryAssistant.joinRecordListApi)(this.queryParams).then(function (res) {
        _this.recordList = res.list || [];
        _this.total = res.total || 0;
        _this.loading = false;
      }).catch(function (error) {
        console.error('API错误：', error);
        _this.loading = false;
      });
    },
    handleQuery: function handleQuery() {
      this.queryParams.page = 1;
      // 确保userId是数字类型
      if (this.queryParams.userId !== '') {
        this.queryParams.userId = parseInt(this.queryParams.userId) || '';
      }
      this.getList();
    },
    resetQuery: function resetQuery() {
      this.dateRange = [];
      this.queryParams = {
        page: 1,
        limit: 20,
        activityId: '',
        phoneNumber: '',
        redeemCode: '',
        userId: '',
        winStatus: '',
        userType: '',
        startTime: '',
        endTime: '',
        temp: new Date().getTime()
      };
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryParams.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getList();
    },
    formatPrizeType: function formatPrizeType(value) {
      //const target = prizeTypeOptions.find((item) => item.value == value);
      //return target ? target.label : value;
      //奖品类型（1:积分;2:实物;3:红包;99:谢谢参与）
      return value === 1 ? '积分' : value === 2 ? '实物' : value === 3 ? '红包' : value === 99 ? '谢谢参与' : value;
    },
    formatWinStatus: function formatWinStatus(value) {
      //const target = winStatusOptions.find((item) => item.value === value);
      //return target ? target.label : value;
      // 0:待开奖，1:未中奖，2：已中奖，3：已领取
      return value === 0 ? '待开奖' : value === 1 ? '未中奖' : value === 2 ? '已中奖' : value === 3 ? '已领取' : value === 4 ? '已过期' : value;
    },
    formatUserType: function formatUserType(value) {
      //const target = userTypeOptions.find((item) => item.value === value);
      //return target ? target.label : value;
      return value === 1 ? '真人' : '机器人';
    },
    getWinStatusTag: function getWinStatusTag(value) {
      switch (value) {
        case 0:
          return 'info';
        // 待开奖
        case 1:
          return 'danger';
        // 未中奖
        case 2:
          return 'success';
        // 已中奖
        case 3:
          return 'warning';
        // 已领取
        default:
          return '';
      }
    },
    handleDateChange: function handleDateChange(val) {
      if (val) {
        // 开始日期添加起始时间
        this.queryParams.startTime = val[0] + ' 00:00:00';
        // 结束日期加上结束时间，使其包含当天的所有记录
        this.queryParams.endTime = val[1] + ' 23:59:59';
      } else {
        this.queryParams.startTime = '';
        this.queryParams.endTime = '';
      }
    },
    // 处理发放操作
    handleDelivery: function handleDelivery(row) {
      var _this2 = this;
      this.$modalSure("\u786E\u5B9A\u8981\u53D1\u653E\u5956\u54C1\"".concat(row.prizeName, "\"\u7ED9\u7528\u6237\u5417\uFF1F")).then(function () {
        (0, _lotteryAssistant.joinRecordUpdateStatusApi)(row.recordId).then(function (res) {
          _this2.$message.success('发放成功');
          _this2.getList();
        }).catch(function () {
          _this2.$message.error('发放失败');
        });
      }).catch(function () {
        // 取消操作，不做任何处理
      });
    }
  }
};